var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27351",
    "data-name": "Group 27351",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.799,
    height: 17.799,
    viewBox: "0 0 17.799 17.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49139",
    "data-name": "Path 49139",
    d: "M0,0H17.8V17.8H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49140",
    "data-name": "Path 49140",
    d: "M3,9.674A6.674,6.674,0,1,0,9.674,3,6.674,6.674,0,0,0,3,9.674",
    transform: "translate(-0.775 -0.775)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49141",
    "data-name": "Path 49141",
    d: "M3.6,9H16.059",
    transform: "translate(-0.93 -2.326)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49142",
    "data-name": "Path 49142",
    d: "M3.6,15H16.059",
    transform: "translate(-0.93 -3.876)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49143",
    "data-name": "Path 49143",
    d: "M10.834,3a12.607,12.607,0,0,0,0,13.349",
    transform: "translate(-2.305 -0.775)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49144",
    "data-name": "Path 49144",
    d: "M12.5,3a12.607,12.607,0,0,1,0,13.349",
    transform: "translate(-3.23 -0.775)",
    fill: "none",
    stroke: "#06233d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.f449eac22f98d8c1d37ce9587a2d5940.svg";
export { ForwardRef as ReactComponent };